import React, { useContext } from 'react';
import dayjs from 'dayjs';
import { makeStyles } from '@mui/styles';
import { CustomButtonsForm } from '../../CustomButtonsForm';
import { CustomInputText } from '../../CustomInputText';
import { Grid } from '@mui/material';
import { CustomInputSelect } from '../../CustomInputSelect';
import { useSedes } from '../../../hooks/useSedes';
import { useForm, Controller } from 'react-hook-form';
import { LoaderContext } from '../../../contexts/LoaderContext';
import { SocketContext } from '../../../contexts/SocketContext';
import { AlertContext } from '../../../contexts/AlertContext';
import { ModalsContext } from '../../../contexts/ModalsContext';
import { exportarExcel } from "../../../helpers/exportarExcel";
import { useSurveys } from '../../../hooks/encuestas/useSurveys';
import { formatearHora } from '../../../helpers/fechaHoras';
import { AuthContext } from '../../../contexts/AuthContext';
import { useModalStore } from '../../../store/useModalStore';

export const ResponseForm = () => {

    const classes = useStyles();
    const { sedes } = useSedes();
    const { surveys } = useSurveys();

    const { handleSubmit, control, formState: { errors } } = useForm();

    const { usuario } = useContext(AuthContext);
    const { setOpenLoader } = useContext(LoaderContext);
    const { socket } = useContext(SocketContext);
    const { alertRef } = useContext(AlertContext);
    // const { modalRef } = useContext(ModalsContext);
    const { closeModal } = useModalStore();

    const onSubmit = (args) => {
        responseExtraction(args);
    }

    const responseExtraction = (args) => {
        setOpenLoader(true);
        socket.emit('frontend:extraccion-respuestas', args, response => {
            const { ok, message, data } = response;
            
            if(!ok) {
                setOpenLoader(false);
                alertRef?.current?.handleOpen('error', message);
                return;
            }

            let newObj = {};

            const newArr = data?.map(d => {
                d?.preguntas?.forEach(p => {
                    newObj = { ...newObj, [p?.pregunta?.toLowerCase()]: p?.respuesta, pqrs: p?.pqrs };
                });

                return ({
                    encuesta: d?.titulo_encuesta?.toLowerCase(),
                    código: d?.codigo_encuesta?.toLowerCase(),
                    canal: d?.canal?.toLowerCase(),
                    servicio: d?.servicio?.toLowerCase(),
                    sede: d?.sede?.toLowerCase(),
                    fecha: dayjs(d?.creado).format('DD-MM-YYYY'),
                    hora: formatearHora(d?.creado),
                    evaluado: d?.usuario?.toLowerCase(),
                    cliente: d?.cliente?.nombre || 'anónimo',
                    ip: d?.ip || '',
                    ...newObj
                })
            });

            // modalRef?.current?.handleClose();
            closeModal();
            setOpenLoader(false);
            exportarExcel(newArr, `${args?.titulo_encuesta?.toLowerCase()}_${ dayjs().format('DDMMYYYY') }`)
        });
    }

    return (
        <form className={classes.form} onSubmit={ handleSubmit(onSubmit) }>
            <Grid container spacing={ 2 }>
                <Grid item xs={ 10 } sm={ 10 } md={ 6 } lg={ 6 } xl={ 6 }>
                    <Controller 
                        name='inicial'
                        control={ control }
                        defaultValue=''
                        render={({ field: { onChange, value } }) => (
                            <CustomInputText 
                                label='Desde'
                                type='date'
                                onChange={ onChange }
                                value={ value }
                                error={ errors?.inicial }
                            />
                        )}
                        rules={{
                            required: '* La fecha inicial es requerida.'
                        }}
                    />
                </Grid>

                <Grid item xs={ 12 } sm={ 10 } md={ 6 } lg={ 6 } xl={ 6 }>
                    <Controller 
                        name='final'
                        control={ control }
                        defaultValue=''
                        render={({ field: { onChange, value } }) => (
                            <CustomInputText 
                                label='Hasta'
                                type='date'
                                onChange={ onChange }
                                value={ value }
                                error={ errors?.final }
                            />
                        )}
                        rules={{
                            required: '* La fecha final es requerida.'
                        }}
                    />
                </Grid>

                <Grid item xs={ 12 } sm={ 12 } md={ 12 } lg={ 12 } xl={ 12 }>
                    <Controller 
                        name='sede'
                        control={ control }
                        defaultValue=''
                        render={({ field: { onChange, value } }) => (
                            <CustomInputSelect 
                                label='Sede'
                                placeholder='Seleccione una sede'
                                options={sedes.map(a => ({ ...a, name: a?.nombre }))}
                                onChange={ onChange }
                                value={ value }
                                error={ errors?.sede } 
                                type='name'
                                all='todas'
                            />
                        )}
                        rules={{
                            required: '* La sede es requerida.'
                        }}
                    />
                </Grid>

                <Grid item xs={ 12 } sm={ 12 } md={ 12 } lg={ 12 } xl={ 12 }>
                    <Controller 
                        name='titulo_encuesta'
                        control={ control }
                        defaultValue=''
                        render={({ field: { onChange, value } }) => (
                            <CustomInputSelect 
                                label='Encuesta'
                                placeholder='Seleccione una encuesta'
                                options={
                                    (usuario?.rol?.nombre === 'admin' || usuario?.rol?.nombre === 'super')
                                        ? [...new Set(surveys.map(e => JSON.stringify(e.titulo?.props?.children[0]?.props?.children)))].map(JSON.parse).map(a => ({ name: a }))
                                        : [...new Set(surveys.filter(s => s?.area?._id === usuario?.area).map(e => JSON.stringify(e.titulo?.props?.children[0]?.props?.children)))].map(JSON.parse).map(a => ({ name: a }))
                                }
                                onChange={ onChange }
                                value={ value }
                                error={ errors?.titulo_encuesta } 
                                type='name'
                            />
                        )}
                        rules={{
                            required: '* La encuesta es requerida.'
                        }}
                    />
                </Grid>
            </Grid>
           
            <CustomButtonsForm name='Generar'/>
        </form>
    )
}

const useStyles = makeStyles({
    form: {
        margin: '30px 30px 20px 30px', 
        position: 'relative',  
        width: 350
    }
});